import React from 'react';
import { Button, Tooltip, Tag, } from 'antd';

import CustomTable from '../../../components/CustomTable';

export default function ResultList(props) {
    return (
        <CustomTable
            loadingExcel={props.loadingExcel}
            loadingPdf={props.loadingPdf}
            loadingPrint={props.loadingPrint}
            onExportExcel={props.onExportExcel}
            onExportPdf={props.onExportPdf}
            onPrint={props.onPrint}
            onChange={props.onChange}
            pagination={props.pagination}
            rowKey={record => record.id}
            columns={[
                {
                    title: 'Opciones',
                    width: "100px",
                    key: 'options',
                    align: 'center',
                    render: (value, row) => (
                        <div className="custom-options">
                            <Tooltip placement="top" title={"Editar"}>
                                <Button
                                    disabled={!row.flag}
                                    type="primary"
                                    icon="edit"
                                    size={"small"}
                                    loading={props.loadingEdit}
                                    onClick={() => props.onEdit(row)}
                                />
                            </Tooltip>
                            <Tooltip placement="top" title={row.flag ? "Deshabilitar" : "Habilitar"}>
                                <Button
                                    type={row.flag ? "danger" : "success"}
                                    icon={row.flag ? "close" : "check"}
                                    size={"small"}
                                    onClick={() => props.onDeleteActive(row)}
                                />
                            </Tooltip>
                        </div>
                    )
                },
                {
                    title: 'Nombre',
                    dataIndex: 'nombre',
                    key: 'nombre',
                    sorter: true
                },
                {
                    title: 'Tasa (%)',
                    dataIndex: 'valor',
                    key: 'valor',
                    sorter: true,
                        render: (data) => (
                        <span>{data.toFixed(2)}</span>
                    )
                },
                {
                    title: 'Tipo Crédito',
                    dataIndex: 'credito',
                    key: 'credito',
                    sorter: true
                },
                {
                    title: 'Estado',
                    dataIndex: 'flag',
                    key: 'flag',
                    align: 'center',
                    width: "90px",
                    render: (value) => {
                        return (<div className="custom-options" >
                            <Tag color={value ? "green" : "red"}>{value ? "Activo" : "Inactivo"}</Tag>
                        </div>)
                    }
                }
            ]}
        />
    );
}